import $ from 'jquery';
import Swiper from 'swiper/dist/js/swiper';

$(document).on('init', '.ui-product-slider', function () {
    const $component = $(this);
    if($component.hasClass('ui-product-slider--initialized')){
        return;
    }
    $component.addClass('ui-product-slider--initialized');

    const swiper = new Swiper($component.find('.ui-product-slider__container'), {
        speed: 600,
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: false,
        autoHeight: true,
        noSwiping: true,
        noSwipingClass: 'ui-product-preview-slider__slide',
        pagination: {
            el: $component.find('.ui-product-slider__pagination'),
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            767: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 0,
            },
            1023: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 12,
            },
            1365: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 12,
            },
            1919: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 35,
            },
            99999: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 12,
            }
        }
    });

    setTimeout(() => {
        swiper.update();
    }, 100)
});

$('.ui-product-slider').trigger('init');
